module.exports = __webpack_public_path__ + "img/study-visitus.29c2dd3d.jpg";